export default "assets/information-8042768d.svg";